(function () {
  // Capture phase (the "true" 3rd arg) is essential here: theme.js's own
  // quantity-update handler is a dom-delegate listener bound to the cart
  // drawer element, which fires during the normal BUBBLE phase. A bubble
  // listener on document would run *after* that handler already fired the
  // /cart/change.js AJAX request — too late to stop it. Listening on
  // document in the CAPTURE phase runs before any bubble-phase listener
  // anywhere in the tree, so it gets first refusal.
  document.addEventListener(
    'click',
    function (e) {
      var plusButton = e.target.closest && e.target.closest('.QuantitySelector__Button--plus');
      if (!plusButton) return;

      if (plusButton.getAttribute('data-limit-reached') !== 'true') {
        return; // Not at the limit — let the click proceed normally (theme.js handles the real increment).
      }

      // At the limit: block both the anchor's default navigation AND the
      // bubble-phase click from ever reaching theme.js's own
      // update-item-quantity delegate, so no request is sent for a
      // quantity Shopify would reject anyway.
      e.preventDefault();
      e.stopPropagation();

      var targetId = plusButton.getAttribute('data-stock-notice-target');
      var notice = targetId && document.getElementById(targetId);
      if (!notice) return;

      notice.classList.add('is-visible');

      // Small shake so a shopper who's already looking at the price/qty
      // row (rather than scanning below it) also notices something
      // happened, without needing to scroll down to see it appear.
      notice.classList.remove('CartItemDrawer__StockNotice--shake'); // restart animation on repeated clicks
      // Force reflow so removing+re-adding the class actually re-triggers the animation.
      void notice.offsetWidth;
      notice.classList.add('CartItemDrawer__StockNotice--shake');
    },
    true
  );
})();